import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { useMemo } from 'react';

import { CUSTOM_SCENARIOS_HINT, CUSTOM_SCENARIOS_SECTION_TITLE } from '../../../constants/oneLink';
import { IOneLinkWithCampaignSummaries } from '../../../types/oneLink';
import { LabeledField, Section } from './common';

interface IProps {
  instance: IOneLinkWithCampaignSummaries | null | undefined;
}

export const CustomScenariosSection: React.FC<IProps> = ({ instance }) => {
  const scenarios = useMemo(() => instance?.custom_scenarios ?? [], [instance?.custom_scenarios]);

  if (!scenarios.length) {
    return null;
  }

  return (
    <Section title={CUSTOM_SCENARIOS_SECTION_TITLE}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {scenarios.map((scenario) => (
          <LabeledField
            key={scenario.value}
            label={scenario.label}
            value={scenario.value}
            valueSx={{ fontFamily: 'monospace', wordBreak: 'break-all' }}
          />
        ))}
        <Typography variant="caption" color="text.secondary">
          {CUSTOM_SCENARIOS_HINT}
        </Typography>
      </Box>
    </Section>
  );
};
